function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import { TotalsCell } from './TotalsCell';
import { DefaultCell } from './DefaultCell';

/**
 * Hook to transform header definitions into react-data-grid column definitions
 * 
 * @param {Array} headers - Header definitions with properties like text, valueFn, cellType, etc.
 * @param {Object} totalsRow - Optional hash mapping header text to totals value
 * @returns {Array} Transformed column definitions for react-data-grid
 */
export function useTransformHeadersToColumns(headers, totalsRow) {
  return useMemo(() => {
    return headers.map((header, index) => {
      // If header doesn't have renderCell, provide default
      const defaultRenderCell = _ref => {
        let {
          row,
          column,
          tabIndex
        } = _ref;
        // Totals row takes priority
        if (row.isTotalsRow) {
          return /*#__PURE__*/React.createElement(TotalsCell, {
            headerText: header.text,
            totalsRow: column.totalsRow
          });
        }

        // Default cell with valueFn
        const wrappedRow = {
          data: {
            object: row
          }
        };
        const displayValue = header.valueFn ? header.valueFn(wrappedRow) : '';

        // Check if cell is editable (use editable function if available, otherwise check cellType/disabled)
        const isEditable = column.editable ? column.editable(row) : header.cellType && !header.disabled;
        return /*#__PURE__*/React.createElement(DefaultCell, {
          header: header,
          value: displayValue,
          isEditable: isEditable,
          tabIndex: tabIndex
        });
      };
      return _objectSpread(_objectSpread({
        key: "col_".concat(index),
        name: header.text,
        resizable: true,
        totalsRow
      }, header), {}, {
        // Spread all header properties directly onto column
        renderCell: header.renderCell || defaultRenderCell // Use header's renderCell or default
      });
    });
  }, [headers, totalsRow]);
}